var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightImgAirport = function SvgLightImgAirport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 35,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 1h4.975c2.89 0 4.547 1.766 4.547 4.258s-1.68 4.238-4.602 4.238H6.638V13.6H4.002V1zm4.49 6.386c1.564 0 2.32-.867 2.32-2.128s-.756-2.11-2.327-2.11h-1.85v4.238H8.49"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#light_img_airport_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.263 21.175 1.374-.971a.7.7 0 0 1 .586-.103l6.066 1.67c.17.048.35.029.509-.05L35.198 12s1.776-1.283 4.159-.947l3.05.926s.919.308.983 1.046c.032.374-.193.725-.526.892l-2.838 1.428-7.399 3.596-4.806 10.748s-.556 1.711-1.836 2.762a3.1 3.1 0 0 1-1.178.587l-.166.043a.275.275 0 0 1-.345-.286l.682-9.968a.3.3 0 0 0-.409-.3l-8.45 3.439c-.41.188-.738.104-1.243-.15l-7.64-3.645a.622.622 0 0 1 .027-.995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.38 17.235 3.891-1.959c.18-.089.142-.356-.053-.394l-7.34-1.439s-1.41-.33-2.69.091a1.96 1.96 0 0 0-.758.47l-.014.012a.61.61 0 0 0 .204 1.006l5.756 2.258c.327.127.69.11 1.003-.047z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "light_img_airport_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7 11h36.391v22.095H7z"
  })))));
};
export default SvgLightImgAirport;